import React from 'react';

const Home = () => {
    return (
        <div>
            <h2>This is Home Component</h2>
        </div>
    );
};

export default Home;